import { toPersianDigits } from './recipeTime.js';

// Customer comments on recipe-book recipes (backend Phase 42). Comments are written and moderated
// in the apps and admin panel; the landing site only shows approved threads, read-only.

export const MAX_REVIEWS_IN_SCHEMA = 5;

// A fixed calendar and timezone, so the server-rendered date and the hydrated one are identical.
const DATE_FORMAT = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    timeZone: 'Asia/Tehran',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
});

export const formatCommentDateFa = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : DATE_FORMAT.format(date);
};

/**
 * «۴.۵» for an average: one decimal, Persian digits. A dot, not «٫»: in the site font «٫» looks like
 * a slash, and «۴/۵» next to five stars reads as "4 out of 5".
 */
export const formatRatingFa = (value) => {
    const rounded = Math.round(Number(value) * 10) / 10;
    if (!Number.isFinite(rounded)) return '';
    return toPersianDigits(Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1));
};

/** The first letter of a name, for the avatar circle; `fallback` when the name is empty. */
export const nameInitial = (name, fallback = 'ه') => {
    const letter = Array.from(String(name || '').trim())[0];
    return letter || fallback;
};

const hasRatings = (recipe) => Number(recipe?.ratingCount) > 0 && Number(recipe?.ratingAverage) > 0;

/**
 * schema.org `aggregateRating` and `review` for the Recipe rich result. Only approved, visible
 * ratings are used (the API serves nothing else), and only reviews shown on the page.
 */
export const reviewStructuredData = (recipe, commentThreads = []) => {
    if (!hasRatings(recipe)) return {};

    const reviews = (commentThreads || [])
        .filter((comment) => !comment.deleted && !comment.isOfficial && comment.rating >= 1 && comment.body && comment.author?.name)
        .slice(0, MAX_REVIEWS_IN_SCHEMA)
        .map((comment) => ({
            '@type': 'Review',
            author: { '@type': 'Person', name: comment.author.name },
            datePublished: comment.createdAt || undefined,
            reviewBody: comment.body,
            reviewRating: { '@type': 'Rating', ratingValue: comment.rating, bestRating: 5, worstRating: 1 },
        }));

    return {
        aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: Math.round(Number(recipe.ratingAverage) * 10) / 10,
            ratingCount: Number(recipe.ratingCount),
            bestRating: 5,
            worstRating: 1,
        },
        review: reviews.length ? reviews : undefined,
    };
};
